<form [formGroup]="form">
  <ul>
    @for (divisionControl of divisionControlArr; track divisionControl; let i = $index) {
      <li>
        <mat-form-field class="form-field form-field-search" [floatLabel]="'always'">
          <label [for]="'rank-' + i" [innerHTML]="labels[i] || 'label'"> </label>
          <input
            matInput
            (keyup)="handleValueChange(divisionControl[1])"
            (change)="handleValueChange(divisionControl[1])"
            oninput="this.value = Math.abs(this.value)"
            (click)="handleInputClick(divisionControl[1])"
            (blur)="handleInputBlur(divisionControl[1])"
            [formControl]="divisionControl[1]"
            [id]="'rank-' + i"
            min="0"
            type="number"
          />
        </mat-form-field>
      </li>
    }
  </ul>
  @if (withTransloco) {
    <p class="points-left-container" [ngClass]="{ 'with-error': pointsLeft < 0 }">
      <strong>{{ pointsLeft }}</strong> {{ 'form.field.points_left' | transloco }}
    </p>
    @if (pointsLeft < 0) {
      <mat-error>{{ 'form.error.you_assigned_too_many' | transloco }}</mat-error>
    }
  }
  @if (!withTransloco) {
    <p class="points-left-container" [ngClass]="{ 'with-error': pointsLeft < 0 }">
      <strong>{{ pointsLeft }}</strong> {{ 'form.field.points_left' | transloco }}
    </p>
    @if (pointsLeft < 0) {
      <mat-error>{{ 'form.error.you_assigned_too_many' | transloco }}</mat-error>
    }
  }
</form>
